import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@ami/react/core';
import { Quote } from '../../../quotes/quote';
import { quoteReOpeningStatus } from '../quoteView';
import { Input } from 'reactstrap';
import { NotificationManager } from 'react-notifications';

export default class ReOpenQuoteConfirmationModal extends React.Component {
  state = {
    show: false,
    saving: false,
    confirmText: '',
  };
  static propTypes = {
    quoteId: PropTypes.string.isRequired,
    canBeReOpenedStatus: PropTypes.number.isRequired,
    onChanged: PropTypes.func.isRequired,
    productsWithValidationErrors: PropTypes.array.isRequired,
  };

  show() {
    this.setState({ show: true });
  }

  hide = () => this.setState({ show: false });

  save = () => {
    this.setState({ saving: true });
    var saveFunction = this.getSaveFunction();
    saveFunction(this.props.quoteId)
      .then(() => {
        this.props.onChanged();
        NotificationManager.success('Quote re-opened');
        this.hide();
      })
      .catch(() => {})
      .finally(() => this.setState({ saving: false }));
  };

  getSaveFunction = () => {
    switch (this.props.canBeReOpenedStatus) {
      case quoteReOpeningStatus.allowed:
        return Quote.reOpen;
      case quoteReOpeningStatus.forbiddenForDealer:
        return Quote.requestReOpen;
      default:
        throw new Error('Invalid operation in quote when trying to re-open');
    }
  };

  render() {
    const { show, saving, confirmText } = this.state;
    const { productsWithValidationErrors } = this.props;

    const message =
      this.props.canBeReOpenedStatus === quoteReOpeningStatus.allowed
        ? 'Are you sure want to re-open this quote?'
        : 'Unfortunately, this quote cannot be re-opened automatically either because some of the products are no longer offered, or because the quote includes customizations. If you continue, AMI will be notified that you would like this quote re-opened and someone will get in touch with you regarding next steps.';

    return (
      <Modal
        title="Re-open Quote"
        show={show}
        //onShowUpdated={() => { }}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        okTitle="Confirm"
        cancelTitle="Dismiss"
        onOk={this.save}
        showCancel={true}
        submitting={saving}
        okDisabled={
          productsWithValidationErrors.length > 0 && confirmText !== 'CONFIRM'
        }
      >
        {productsWithValidationErrors.length > 0 && (
          <div>
            <p>
              The following products had their configuration changed and will be
              automatically removed from the quote. If you still want these
              products to be included on the quote, you are responsible for
              manually adding them back onto the quote after it gets re-opened.
            </p>
            <ul>
              {productsWithValidationErrors.map((x, idx) => (
                <li key={idx}>
                  <strong>{x.productGroupName}:</strong> {x.productPartNumber}
                </li>
              ))}
            </ul>
          </div>
        )}
        <p>{message}</p>
        {productsWithValidationErrors.length > 0 && (
          <p>
            Please enter 'CONFIRM' to confirm
            <Input
              value={confirmText}
              onChange={(e) => this.setState({ confirmText: e.target.value })}
            />
          </p>
        )}
      </Modal>
    );
  }
}
